export default async function uploadAttachment(file, attachmentsURL, token) {
  let attachmentID;

  const fileName = `${file.name?.replace(/"/g, '\'')}`;

  const requestBody = {
    name: fileName,
    owners: [
      {
        type: 'record',
      },
    ],
    file_size: file.size,
    metadata: {
      filename: fileName,
    },
  };

  async function getPresignedURL() {
    const response = await fetch(`${attachmentsURL}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-ApiToken': token },
      body: JSON.stringify(requestBody),
    }).catch(() => {
      throw new Error('Upload failed. Please try again.');
    });

    return response.json();
  }

  await getPresignedURL().then((response) => {
    attachmentID = response.id;

    // upload to S3 //
    return fetch(response.url, {
      method: 'PUT',
      body: file,
      headers: response.headers,
    });
  }).catch(() => {
    throw new Error('Upload failed. Please try again.');
  });

  return attachmentID;
}
